<template>
  <b-button variant="outline-secondary" class="facebook-login-lg w-100">
    <font-awesome-icon :icon="['fab', 'facebook-square']" />
    <span>{{ buttonText }}</span>
  </b-button>
</template>

<script>
export default {
  name: "facebook-button",
  props: {
    buttonText: String
  }
};
</script>

<style scoped></style>
